export const ServiceLabel = {
  BASIC: "Basic",
  ADVANCED: "Advanced",
  PREMIUM: "Premium"
} as const;

export const ServiceCategory = {
  COMPREHENSIVE: "comprehensive-testing",
  COACHING: "mentoring-coaching",
  CROWDTESTING: "crowd-testing"
}

export type ServiceLabel = typeof ServiceLabel[keyof typeof ServiceLabel];

export type ServiceCategory = typeof ServiceCategory[keyof typeof ServiceCategory]


export interface ServiceData {
  id: string;
  title: string;
  description: string; 
  icon: any;
  color: string;
  bgColor: string;
  labels: ServiceLabel[];
  category: ServiceCategory
  process?: Array<{ title: string; description: string; icon: string }>;
  bestPractices?: Array<{ title: string; description: string }>;
}
